import React, { Component } from 'react'

import { compose } from 'recompose'

let ReactDOM = require( 'react-dom' )

import Timeout from 'mixins/Timeout'
import * as ArraysHelper from 'helpers/Arrays'

import $ from 'jquery'

const ratio = ( selector, ratio, side, padding ) => {

    if( side === undefined ) side = 'width'
    if( padding === undefined ) padding = false

    $( selector ).each(function ( index, el ) {
        let $selector = $( el )

        if( side == 'width' )
        {
            let _width  = padding ? $selector.outerWidth() : $selector.width()
            let _height = _width / ratio

            $selector.css({
                height: _height,
                width: ''
            })
        } else {
            let _height = padding ? $selector.outerHeight() : $selector.height()
            let _width  = _height / ratio

            $selector.css({
                width: _width,
                height: ''
            })
        }
    })
}

const RatioMixin = WrappElement => (class extends Component {
    handleUpdateView__Ratio() {
        // console.log( 'RatioMixin Update' )

        var DOMthis = ReactDOM.findDOMNode( this )

        if( DOMthis && DOMthis.querySelectorAll )
        {
            const rationElements = DOMthis.querySelectorAll( '[data-ratio]' )

            ArraysHelper.forEach( rationElements, element => {
                const ratioValue = element.getAttribute( 'data-ratio' )
                const side       = element.getAttribute( 'data-side' ) ? element.getAttribute( 'data-side' ) : 'width'
                const padding    = ( element.getAttribute( 'data-padding' ) == 'yes' ? true : false )
                const width      = parseFloat( element.clientWidth )
                const lastWidth  = parseFloat( element.getAttribute( 'data-width' ) )

                if( lastWidth !== width )
                {
                    ratio( element, ratioValue, side, padding )

                    element.setAttribute( 'data-width', width )
                }
            })

            this.props.setTimeout( ::this.handleUpdateView__Ratio, 200 )
        }
    }

    componentDidMount() {
        this.handleUpdateView__Ratio()
    }

    componentDidUpdate() {
        this.handleUpdateView__Ratio()
    }

    render() {
        return (
            <WrappElement { ...this.props } />
        )
    }
})

const Ratio = compose(
    Timeout,
    RatioMixin
)

export { ratio }

export default Ratio